/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_HerkunftInputs */

const en__field_herkunft = /** @type {(inputs: _Field_HerkunftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrival`)
};

const de__field_herkunft = /** @type {(inputs: _Field_HerkunftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anreise`)
};

/**
* | output |
* | --- |
* | "Arrival" |
*
* @param {_Field_HerkunftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_herkunft = /** @type {((inputs?: _Field_HerkunftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_HerkunftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_herkunft(inputs)
	return de__field_herkunft(inputs)
});